import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Vietnamese Citizen Identity Card validator following Single Responsibility Principle
 */
export class VnValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Vietnamese Citizen Identity Card',
      pattern: /^\d{12}$/,
      length: 12
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Vietnamese ID must be exactly 12 digits'
    );
  }

  validateChecksum(id) {
    // Vietnamese ID structure validation
    const provinceCode = id.substring(0, 3);
    const genderCentury = id.substring(3, 4);
    const birthYear = id.substring(4, 6);
    
    // Basic structure validation
    if (parseInt(provinceCode) < 1 || parseInt(provinceCode) > 96) {
      return ValidationResult.invalid('Invalid province code');
    }
    
    if (parseInt(genderCentury) < 0 || parseInt(genderCentury) > 9) {
      return ValidationResult.invalid('Invalid gender/century code');
    }

    return ValidationResult.valid('Valid Vietnamese ID');
  }
}